"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _Input = _interopRequireDefault(require("../Input"));
var _Button = _interopRequireDefault(require("../Button"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// 在这里引入其他组件，样式在 style/index.ts 中引入

var ChatWindowEditor = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var onChange = props.onChange,
    onSend = props.onSend,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? '向我提问图片内容相关问题 或 “/”获取问题模板' : _props$placeholder,
    className = props.className,
    style = props.style,
    value = props.value;
  var _useState = (0, _react.useState)(value),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    inputVal = _useState2[0],
    setInputVal = _useState2[1];
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('chat-window__editor');
  var classes = (0, _classnames.default)(prefixCls, className);
  (0, _react.useEffect)(function () {
    setInputVal(value);
  }, [value]);
  var handleSend = function handleSend() {
    onSend && onSend(inputVal);
  };
  var handleChange = function handleChange(e) {
    setInputVal(e);
    onChange && onChange(e);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    style: style,
    ref: ref
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    value: value,
    width: "full",
    suffix: /*#__PURE__*/_react.default.createElement(_Button.default, {
      onClick: function onClick() {
        return handleSend();
      },
      prefixIcon: /*#__PURE__*/_react.default.createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M8.81722858,15.5606176 L13.3957186,11.5364176 C13.6860186,11.2811176 13.7145186,10.8388176 13.4593186,10.5485176 C13.2041186,10.2581176 12.7618186,10.2296176 12.4714186,10.4848176 L7.71862858,14.6623176 L2.41429858,11.3404176 C1.72638858,10.9096176 1.81123858,9.88191763 2.56049858,9.56976763 L20.9413186,1.91224763 C21.6810186,1.60412763 22.3025186,2.42427763 21.9568186,3.03314763 L14.4915186,21.5289176 C14.1871186,22.2832176 13.1575186,22.3778176 12.7207186,21.6917176 L8.81722858,15.5606176 Z"
      }))
    }),
    placeholder: placeholder,
    onChange: function onChange(e) {
      return handleChange(e);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter') {
        handleSend();
      }
    }
  }));
});
ChatWindowEditor.defaultProps = {};
var _default = exports.default = ChatWindowEditor;